module.exports = __webpack_public_path__ + "img/ascend_gold20.b7f15410.png";